import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SettingsService } from '../../../services/settings.service';
import { SettingsEventType } from '../../../models/enums/settingsEventType';

@Component({
  selector: 'app-settings-widget',
  templateUrl: './settings-widget.component.html',
  styleUrls: ['./settings-widget.component.scss'],
  })
export class SettingsWidgetComponent implements OnInit {
  static widgetName = 'settings';
  languageOptions: string[];

  public timeoutDays = 0;
  public timeoutHours = 0;
  public timeoutMinutes = 0;

  constructor(
    public translate: TranslateService,
    private settingsService: SettingsService,
  ) {
    this.languageOptions = this.translate.getLangs();
    this.setCurrentLanguage();
  }

  ngOnInit() {
    const totalMinutes = this.settingsService.getMarkAsUnseenTimeout();
    this.convertTotalMinutesToTime(totalMinutes);
  }

  setCurrentLanguage(): void {
    const currentLang = this.settingsService.getLanguage() || this.translate.getBrowserLang();
    this.translate.use(currentLang);
  }

  changeLanguage(event): void {
    const language: string = event.target.value;
    this.settingsService.setLanguage(language);
    this.translate.use(language);
  }

  onSaveThreshold(): void {
    const totalMinutes = (this.timeoutDays * 24 * 60) + (this.timeoutHours * 60) + this.timeoutMinutes;
    this.settingsService.setMarkAsUnseenTimeout(totalMinutes);
    this.settingsService.emitSettingsUpdate(SettingsEventType.RED_THRESHOLD_CHANGED, 'SettingsWidgetComponent');
  }

  private convertTotalMinutesToTime(totalMinutes: number): void {
    this.timeoutDays = Math.floor(totalMinutes / (24 * 60));
    const remainingMinutesAfterDays = totalMinutes % (24 * 60);
    this.timeoutHours = Math.floor(remainingMinutesAfterDays / 60);
    this.timeoutMinutes = remainingMinutesAfterDays % 60;
  }
}
